// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__39RJh","list":"BalanceDue_list__s8_oS","listRow":"BalanceDue_listRow__1MLYI","total":"BalanceDue_total__1Ax-5"};